export default __webpack_public_path__ + "static/media/logo.e37596a6.svg";